<template>
    <canvas ref="chart" width="100" height="100" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { Chart, type TooltipItem } from "./chart";

const chart = ref<HTMLCanvasElement | null>(null);
const parameters: any = {
    type: "line",
    data: {
        labels: [
            "Day 1",
            "Day 2",
            "Day 3",
            "Day 4",
            "Day 5",
            "Day 6",
            "Day 7",
            "Day 8",
            "Day 9",
            "Day 10",
            "Day 11",
            "Day 12",
            "Day 13",
            "Day 14",
            "Day 15",
            "Day 16",
            "Day 17",
            "Day 18",
            "Day 19",
            "Day 20",
            "Day 21",
            "Day 22",
            "Day 23",
            "Day 24",
            "Day 25",
            "Day 26",
            "Day 27",
            "Day 28",
            "Day 29",
            "Day 30",
        ],
        datasets: [
            {
                label: "Joint Pain Relief with Placebo",
                data: [
                    3.85, 3.85, 7.69, 3.85, 11.54, 15.38, 11.54, 15.38, 15.38,
                    15.38, 19.23, 23.08, 26.92, 19.23, 23.08, 30.77, 30.77,
                    30.77, 30.77, 26.92, 30.77, 23.08, 23.08, 30.77, 30.77,
                    30.77, 30.77, 26.92, 26.92, 26.92,
                ],
                backgroundColor: "rgba(252, 101, 133, 0.3)",
                borderColor: "rgba(252, 101, 133, 1)",
                borderWidth: 1,
                fill: true,
            },
            {
                label: "Joint Pain Relief with RediMove",
                data: [
                    3.7, 7.41, 29.63, 40.74, 44.44, 55.56, 59.26, 66.67, 66.67,
                    66.67, 74.07, 70.37, 74.07, 77.78, 85.19, 81.48, 85.19,
                    81.48, 81.48, 85.19, 81.48, 81.48, 81.48, 85.19, 85.19,
                    81.48, 85.19, 85.19, 85.19, 85.19,
                ],
                backgroundColor: "rgba(24, 140, 251, 0.3)",
                borderColor: "rgba(24, 140, 251, 1)",
                borderWidth: 1,
                fill: true,
            },
        ],
    },
    options: {
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value: number | string) {
                        return `${value}%`;
                    },
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context: TooltipItem<"line">) {
                        return `${context.dataset.label?.includes("RediMove") ? "RediMove" : "Placebo"} - ${context.formattedValue}%`;
                    },
                },
            },
        },
    },
};

onMounted(() => {
    if (chart.value) {
        new Chart(chart.value, parameters);
    }
});
</script>
